export default "__VITE_ASSET__Cw870pzF__"